import { produce } from 'immer';
import { isObject } from 'lodash';

export const isWorkspaceCondition = (condition) => (
  isObject(condition?.configuration_schema?.properties?.existing_workspace_condition)
);

export const hasWorkspaceCondition = (datasetConditions) => (
  datasetConditions?.some((datasetCondition) => isWorkspaceCondition(datasetCondition?.condition))
);

export const isAdvisory = (datasetCondition) => datasetCondition?.configuration?.existing_workspace_condition === 'off';

const toggleAdvisoryOnCondition = (datasetCondition) => {
  if (isWorkspaceCondition(datasetCondition.condition)) {
    return produce(datasetCondition, (draft) => {
      draft.configuration.existing_workspace_condition = (isAdvisory(draft)) ? 'on' : 'off';
    });
  }
  return datasetCondition;
};

export const restrictionsAttachmentsMap = new Map();

export default toggleAdvisoryOnCondition;
